export type BeachPopVariant = "public" | "private-test";

export function parseBeachPopVariant(value: string | undefined): BeachPopVariant {
  return value === "private-test" ? "private-test" : "public";
}
